import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 3rem;
  z-index: 1000;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
`;

export const ButtonClose = styled.button`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: transparent;
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #00000010;
  }
`;
